// extracted by mini-css-extract-plugin
export default {"wrapper":"BoxHeader_wrapper__iw4BW","header":"BoxHeader_header__PY+Lq","titleHolder":"BoxHeader_titleHolder__UMDo9"};